
import { useEffect, useState } from "react"
import { ChartstwitsRepository } from "../../repository/ChartstwitsRepository";
import { useNavigate } from 'react-router-dom';

export function DashboardModel() {
    const apiModel = ChartstwitsRepository();
    const navigate = useNavigate();
    // const imagePath = apiModel.chartTwitsImagePath;


    const navigateTo = (d:any) =>{
        debugger;
        navigate(`/`+d);
    }
    
    return{navigateTo}
}